import _typeof from "@babel/runtime/helpers/esm/typeof";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

import { useMask } from '@react-input/mask';
import { Button, Text, Textfield, Title } from '@s7/ui-kit';
import classNames from 'classnames/bind';
import { repeat } from 'ramda';
import pathOr from 'ramda/src/pathOr';
import React, { useEffect, useRef, useState } from 'react';
import { Auth } from '../api';
import { useTimer } from '../hooks/useTimer';
import { getTwoFactorAnalyticAlternativeCodeType, getTwoFactorAnalyticCodeType, getTwoFactorAnalyticEvent } from '../Login/utils';
import { useAnalyticsContext } from '../utils/analytics';
import styles from './ConfirmationScreen.css';
import { getInputDescription, getSendCodeToLabel } from './utils';
var cx = classNames.bind(styles);
export var ConfirmationScreen = function ConfirmationScreen(_ref) {
  var dictionary = _ref.dictionary,
      twoFactorDetails = _ref.twoFactorDetails,
      token = _ref.token,
      handleLoginFailure = _ref.handleLoginFailure,
      handleLoginSuccess = _ref.handleLoginSuccess,
      setTwoFactorDetails = _ref.setTwoFactorDetails,
      isDesktop = _ref.isDesktop;

  var _twoFactorDetails$not = twoFactorDetails.notificationDetails,
      notifiedContact = _twoFactorDetails$not.notifiedContact,
      message = _twoFactorDetails$not.message,
      strong = twoFactorDetails.strong,
      remainResendWaitSeconds = twoFactorDetails.remainResendWaitSeconds,
      remainCheckAttempts = twoFactorDetails.remainCheckAttempts,
      _twoFactorDetails$alt = _slicedToArray(twoFactorDetails.alternativeResendTypes, 1),
      alternativeType = _twoFactorDetails$alt[0];

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      code = _useState2[0],
      setCode = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isError = _useState4[0],
      setIsError = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isLoading = _useState6[0],
      setIsLoading = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      isIPhoneMagic = _useState8[0],
      setIsIPhoneMagic = _useState8[1];

  var inputRef = useRef(null);
  var maskRef = useMask({
    mask: repeat('_', strong).join(' '),
    replacement: {
      _: /\d/
    },
    showMask: true
  });
  var currentRef = isIPhoneMagic ? inputRef : maskRef;

  var _useTimer = useTimer(remainResendWaitSeconds, isLoading),
      seconds = _useTimer.seconds,
      time = _useTimer.time;

  var _useAnalyticsContext = useAnalyticsContext(),
      sendEvent = _useAnalyticsContext.sendEvent;

  var onKeyDown = function onKeyDown(event) {
    var key = event.key.toLowerCase();

    if (key === 'backspace' && code.length === strong) {
      setCode('');
    }

    setIsIPhoneMagic(key === 'unidentified' && navigator.platform.toLowerCase() === 'iphone');
  };

  var onChangeCode = function onChangeCode(event) {
    var _ref2, _event$target$value;

    setIsError(false);
    var value = (_ref2 = isIPhoneMagic ? (_event$target$value = event.target.value) === null || _event$target$value === void 0 ? void 0 : _event$target$value.replace(/[\s_]/g, '') : event.target.value) !== null && _ref2 !== void 0 ? _ref2 : '';
    setCode(value);
  };

  var onFocus = function onFocus(event) {
    event.target.selectionStart = event.target.selectionEnd = 0;
  };

  var submitCode = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(e) {
      var response, status, _twoFactorDetails;

      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              e === null || e === void 0 ? void 0 : e.preventDefault();
              setIsLoading(true);
              _context.prev = 2;
              _context.next = 5;
              return Auth.sendConfirmationCode({
                token: token,
                code: code.replace(/\s/g, '')
              });

            case 5:
              response = _context.sent;
              status = pathOr(null, ['data', 'ticket', 'twoFactorDetails', 'status'], response);
              _twoFactorDetails = pathOr(null, ['data', 'ticket', 'twoFactorDetails'], response);
              setTwoFactorDetails(_twoFactorDetails);

              if (!(status === 'CONFIRMED')) {
                _context.next = 12;
                break;
              }

              handleLoginSuccess === null || handleLoginSuccess === void 0 ? void 0 : handleLoginSuccess(response);
              return _context.abrupt("return");

            case 12:
              setIsError(true);
              sendEvent(getTwoFactorAnalyticEvent({
                event_name: 'view_screen',
                step: 'wrong_code',
                type: getTwoFactorAnalyticCodeType(notifiedContact.type)
              }));
              _context.next = 19;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](2);
              handleLoginFailure === null || handleLoginFailure === void 0 ? void 0 : handleLoginFailure(_context.t0);

            case 19:
              _context.prev = 19;
              setIsLoading(false);
              return _context.finish(19);

            case 22:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 16, 19, 22]]);
    }));

    return function submitCode(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  var resendCode = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(contactType) {
      var response, _twoFactorDetails2;

      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setIsLoading(true);
              setCode('');
              setIsError(false);
              _context2.prev = 3;
              _context2.next = 6;
              return Auth.resendConfirmationCode({
                token: token,
                contactType: contactType
              });

            case 6:
              response = _context2.sent;
              _twoFactorDetails2 = pathOr(null, ['data', 'ticket', 'twoFactorDetails'], response);
              setTwoFactorDetails(_twoFactorDetails2);
              _context2.next = 14;
              break;

            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](3);
              handleLoginFailure === null || handleLoginFailure === void 0 ? void 0 : handleLoginFailure(_context2.t0);

            case 14:
              _context2.prev = 14;
              setIsLoading(false);
              return _context2.finish(14);

            case 17:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[3, 11, 14, 17]]);
    }));

    return function resendCode(_x2) {
      return _ref4.apply(this, arguments);
    };
  }();

  var onClickResend = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var _currentRef$current;

      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              sendEvent(getTwoFactorAnalyticEvent({
                event_name: 'click_cta',
                step: 'verification_code',
                result: 'send_again',
                quantity: remainCheckAttempts
              }));
              _context3.next = 3;
              return resendCode(notifiedContact.type);

            case 3:
              (_currentRef$current = currentRef.current) === null || _currentRef$current === void 0 ? void 0 : _currentRef$current.focus();

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function onClickResend() {
      return _ref5.apply(this, arguments);
    };
  }();

  var onClickAlternativeType = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var _currentRef$current2;

      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              sendEvent(getTwoFactorAnalyticEvent({
                event_name: 'click_cta',
                step: 'verification_code',
                result: getTwoFactorAnalyticAlternativeCodeType(notifiedContact.type)
              }));
              _context4.next = 3;
              return resendCode(alternativeType);

            case 3:
              (_currentRef$current2 = currentRef.current) === null || _currentRef$current2 === void 0 ? void 0 : _currentRef$current2.focus();

            case 4:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function onClickAlternativeType() {
      return _ref6.apply(this, arguments);
    };
  }();

  var resendTimerIsOn = seconds !== 0;
  var disabledSecondaryButtons = isLoading || resendTimerIsOn;
  useEffect(function () {
    sendEvent(getTwoFactorAnalyticEvent({
      event_name: 'view_screen',
      step: 'verification_code',
      type: getTwoFactorAnalyticCodeType(notifiedContact.type)
    }));
  }, [twoFactorDetails]);
  useEffect(function () {
    var cleanCode = code.replace(/[\s_]/g, '');

    if (cleanCode.length === strong) {
      submitCode();
    }
  }, [code]);
  useEffect(function () {
    setIsIPhoneMagic(navigator.platform.toLowerCase() === 'iphone');
  }, [navigator.platform]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, !isDesktop && /*#__PURE__*/React.createElement(Title, {
    classes: {
      root: cx('title')
    },
    level: 2
  }, dictionary.t('com.login.2fa.confirmation')), /*#__PURE__*/React.createElement(Text, {
    dangerouslySetInnerHTML: {
      __html: message
    }
  }), /*#__PURE__*/React.createElement("form", {
    onSubmit: submitCode
  }, /*#__PURE__*/React.createElement(Textfield, {
    autoFocus: true,
    classes: {
      root: cx('security-code-field')
    },
    disabled: isLoading,
    inputProps: {
      ref: currentRef,
      autoComplete: 'one-time-code',
      autoFocus: true,
      type: 'text',
      inputMode: 'numeric'
    },
    invalid: isError,
    label: dictionary.t('com.login.2fa.security.code'),
    onChange: onChangeCode,
    onFocus: onFocus,
    onKeyDown: onKeyDown,
    tooltip: getInputDescription(isError, remainCheckAttempts, dictionary),
    value: code
  }), /*#__PURE__*/React.createElement("div", {
    className: cx('action-buttons')
  }, /*#__PURE__*/React.createElement(Button, {
    classes: {
      root: cx('button')
    },
    disabled: remainCheckAttempts === 0,
    loading: isLoading,
    theme: 'b2c',
    type: 'submit'
  }, dictionary.t('com.global.continue')), /*#__PURE__*/React.createElement(Button, {
    classes: {
      root: cx('button')
    },
    disabled: disabledSecondaryButtons,
    onClick: onClickResend,
    theme: 'secondary'
  }, "".concat(dictionary.t('com.login.2fa.resend.code'), " ").concat(resendTimerIsOn ? time : '')), alternativeType && /*#__PURE__*/React.createElement(Text, {
    classes: {
      root: cx('button', 'text-button', _defineProperty({}, 'cursor', !resendTimerIsOn && !isLoading))
    },
    color: disabledSecondaryButtons ? 'N80' : 'N300',
    onClick: disabledSecondaryButtons ? undefined : onClickAlternativeType,
    weight: 'semibold'
  }, getSendCodeToLabel(alternativeType, dictionary)))));
};